// extracted by mini-css-extract-plugin
export default {"melodyVideo":"DK-z","isFullWidth":"EK-z","landingPageVideo":"FK-z","play":"GK-z","iframeVideo":"HK-z","playHidden":"IK-z","fullwidth":"JK-z"};